export const permissions = {
  PERMISSION: {
    VIEW: "permission.view",
    ADD: "permission.add",
    EDIT: "permission.add",
    DELETE: "permission.add"
  },
  USER: {
    VIEW: "user.view",
    ADD: "user.add",
    EDIT: "user.edit",
    DELETE: "user.delete"
  },
  UNITCODE: {
    VIEW: "transaction-code.view",
    ADD: "transaction-code.add",
    EDIT: "transaction-code.edit",
    DELETE: "transaction-code.delete"
  },
  TRANSACTIONTYPE: {
    VIEW: "capex-opex.view",
    ADD: "capex-opex.add",
    EDIT: "capex-opex.edit",
    DELETE: "capex-opex.delete"
  },
  BUSINESSUNITS: {
    VIEW: "business-unit.view",
    ADD: "business-unit.add",
    EDIT: "business-unit.edit",
    DELETE: "business-unit.delete"
  },
  TRANSACTION: {
    VIEW: "transaction.view",
    ADD: "transaction.add",
    EDIT: "transaction.edit",
    DELETE: "transaction.delete"
  },
  AUDITLOG: {
    VIEW: "audit-log.view",
    ADD: "audit-log.add",
    EDIT: "audit-log.edit",
    DELETE: "audit-log.delete"
  },
  RENTAL: {
    VIEW: "rental.view",
    ADD: "rental.add",
    EDIT: "rental.edit",
    DELETE: "rental.delete"
  },
  HOUSERENTAL: {
    VIEW: "house-rental.view",
    ADD: "house-rental.add",
    EDIT: "house-rental.edit",
    DELETE: "house-rental.delete"
  },
  TENANT: {
    VIEW: "tenant.view",
    ADD: "tenant.add",
    EDIT: "tenant.edit",
    DELETE: "tenant.delete"
  },
  // KPI permission - restricted to Admin and SuperAdmin roles only.
  // Regular Users (role 3) do not have access to KPI.
  KPI: {
    VIEW: "kpi.view"
  },
  // External API (Discord bot PAT management).
  EXTERNALAPI: {
    VIEW: "external-api.view",
    ADD: "external-api.add",
    EDIT: "external-api.edit",
    DELETE: "external-api.delete"
  }
};

